import { Component } from "react";
import { observer } from "mobx-react";
import { Flex } from "@radix-ui/themes";

import CategoryFilter from "./CategoryFilter";
import { StoreContext } from "../../../stores/StoreContext";

@observer
class CategoryFilters extends Component {
  static contextType = StoreContext;
  declare context: React.ContextType<typeof StoreContext>;

  render() {
    const { gridStore } = this.context;

    const categories = gridStore.categoryFilters.filters;

    return (
      <Flex wrap="wrap" justify="center" align="center" mx="auto">
        {Array.from<any>(categories.values()).map((category) => {
          if (category.isTopFilter) {
            return <CategoryFilter key={category.id} category={category} />;
          }
        })}
      </Flex>
    );
  }
}

export default CategoryFilters;
